var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnwinds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    fill: "none",
    viewBox: "0 0 31 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E0DFDB",
    d: "M5.918 10a1.25 1.25 0 1 0 .002-2.502A1.25 1.25 0 0 0 5.918 10Zm0 6.25a1.251 1.251 0 1 0 .002-2.502 1.251 1.251 0 0 0-.002 2.502Zm0 6.25a1.25 1.25 0 1 0 .002-2.502 1.25 1.25 0 0 0-.002 2.502Zm20.105-8.75H10.85c-.65 0-1.177.526-1.177 1.175v.15c0 .649.527 1.175 1.177 1.175h15.173c.65 0 1.177-.526 1.177-1.175v-.15c0-.649-.527-1.175-1.177-1.175Zm0 6.25H10.85c-.65 0-1.177.526-1.177 1.175v.15c0 .649.527 1.175 1.177 1.175h15.173c.65 0 1.177-.526 1.177-1.175v-.15c0-.649-.527-1.175-1.177-1.175Zm0-12.5H10.85c-.65 0-1.177.526-1.177 1.175v.15c0 .649.527 1.175 1.177 1.175h15.173c.65 0 1.177-.526 1.177-1.175v-.15c0-.649-.527-1.175-1.177-1.175Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnwinds);
export default __webpack_public_path__ + "static/media/unwinds.fa7f5a8a9ee5ba53104405914789d735.svg";
export { ForwardRef as ReactComponent };